import React from "react";
import { Toaster } from "react-hot-toast";
import Sidebar from "./Sidebar";
import AdminHeader from "./Header";

/**
 * AdminLayout - Main layout wrapper for all admin pages
 * VidyaSetu-style layout with sidebar, header, and content area
 */
const AdminLayout = ({ children }) => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Toaster position="top-right" />
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar - Dynamic Width */}
        <div className="flex-shrink-0 relative" style={{ zIndex: 40 }}>
          <Sidebar />
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Header */}
          <AdminHeader />

          {/* Page Content - Scrollable */}
          <main className="flex-1 overflow-y-auto bg-gray-50">
            <div className="p-6">{children}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
